const services = [
  {
    icon: 'ri-water-flash-line',
    title: 'Pool Pumps',
    description: 'Diagnose weak circulation and replace or repair pumps to keep your pool running right.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Motors',
    description: 'Motor troubleshooting and replacements for reliable performance.',
  },
  {
    icon: 'ri-filter-3-line',
    title: 'Filters',
    description: 'Cleaning, troubleshooting, and replacements to improve water flow and clarity.',
  },
  {
    icon: 'ri-drop-line',
    title: 'Water Treatment',
    description: 'Balance and maintain water for a clean, safe pool.',
  },
  {
    icon: 'ri-fire-line',
    title: 'Heaters',
    description: 'Repair or install heaters so your pool stays comfortable.',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Pool Lights',
    description: 'Fix or replace lighting for safer nights and a better look.',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'Leak Detection',
    description: 'Identify leaks quickly to prevent costly damage.',
  },
  {
    icon: 'ri-layout-line',
    title: 'Coping',
    description: 'Repair or replace coping to restore the edge and finish.',
  },
  {
    icon: 'ri-paint-brush-line',
    title: 'Renovations',
    description: 'Refresh and upgrade your pool with clean, high-quality improvements.',
  },
  {
    icon: 'ri-star-line',
    title: 'Diamond Brite',
    description: 'Diamond Brite repairs/refresh for a durable, premium finish.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Repairs',
    description: 'General repairs for pool equipment and systems.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Maintenance',
    description: 'Ongoing maintenance to keep everything consistent and stress-free.',
  },
];

export default function ServicesGrid() {
  return (
    <section className="bg-light-cyan py-20 md:py-24 relative overflow-hidden">
      {/* Decorative Water Droplets */}
      <div className="absolute top-40 left-20 opacity-5">
        <i className="ri-drop-line text-tropical-teal text-7xl"></i>
      </div>
      <div className="absolute bottom-40 right-10 opacity-5">
        <i className="ri-drop-line text-tropical-teal text-9xl"></i>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group cursor-pointer"
              style={{ boxShadow: '0 6px 16px rgba(77, 208, 225, 0.12)' }}
            >
              <div className="w-14 h-14 flex items-center justify-center mb-5">
                <i className={`${service.icon} text-5xl text-tropical-teal group-hover:text-coral-pink transition-colors duration-300`}></i>
              </div>
              <h3 className="text-2xl font-bold text-charcoal mb-3">{service.title}</h3>
              <p className="text-base text-slate-gray leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}